import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { Context } from '../types';
import { EditorHelper } from '../helpers/editor.helper';

export const useEditorMetaDataStore = defineStore('editor-meta-data', () => {
  const context = ref<Context>(null);

  const setContext = (newContext: Context) => {
    context.value = newContext;
  };

  const isDsr = computed(() => EditorHelper.isDealroomContext(context.value));

  const isDrSenderSite = computed(() =>
    [Context.DsrEdit, Context.DsrTemplate, Context.DsrResource].includes(context.value)
  );

  return {
    setContext,
    context,
    isDsr,
    isDrSenderSite,
  };
});
